var labelStyles = {"partnerships":"partnership-labels--partnerships","appliedPartnership":"partnership-labels--applied-partnership","associatedText":"partnership-labels--associated-text"};

export { labelStyles as default };
//# sourceMappingURL=PartnershipLabels.module.esm.js.map
